/**
 * application index file
 * 
 * @author    Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/application/App';
import registerServiceWorker from './registerServiceWorker';


function isIE() {
  const ua = navigator.userAgent;
  return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
}

if (isIE()){
    alert('Internet Explorer is currently not supported by musOS. Please use Edge, Chrome, Firefox, Opera or Safari.');
}

ReactDOM.render(<App />, document.getElementById('root'));
//registerServiceWorker();
